import React, { useEffect, useState } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";

import { makeStyles, ThemeProvider } from "@material-ui/core/styles";
import TrendingDownIcon from "@material-ui/icons/TrendingDown";
import FileCopyIcon from "@material-ui/icons/FileCopy";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Title from "../Title/Title";
import stockStyle, { theme } from "./StockStyle";
import { Grid, Paper } from "@material-ui/core";
import { Creators as ProdutoActions } from "../../store/ducks/products";

import { copyToClipboard } from "../../utils/js/utilFunctions";
import Loader from "../Loader/Loader";
import { notifySuccess } from "../../utils/js/helpers";

const useStyles = makeStyles((theme) => stockStyle(theme));

const checkProductLowStock = (products) => {
    return products.filter((product) => {
        return product.estoque_atual < product.estoque_minimo ? true : false;
    });
};

const Stock = ({ getProductList, produtos }) => {
    const classes = useStyles();
    const { data, type, loading, error } = produtos;
    const [stock, setStock] = useState([]);
    const copyTable = (objectList) => {
        copyToClipboard(objectList);
        notifySuccess('Lista copiada para o clipboard.');
    };

    useEffect(() => {
        if (!data && !error && !loading) {
            getProductList();
        }

        if ((type === "products/SEARCH_ALL" || type === "products/UPDATE") &&
            data) {
            const productFiltered = checkProductLowStock(data);

            setStock(productFiltered);
        }
    }, [data, type, loading, error, getProductList]);

    return loading ? (
        <Loader />
    ) : !stock || !stock.length ? (
        <span>erro</span>
    ) : (
        <>
            <ThemeProvider theme={theme}>
                <Paper className={classes.tableContainer}>
                    <Grid
                        container
                        direction="row"
                        justify="space-between"
                        alignItems="center"
                    >
                        <Title className={classes.tableTitle}>
                            <TrendingDownIcon />
                            Itens com estoque baixo
                        </Title>
                        <FileCopyIcon
                            className={classes.listCopyButton}
                            onClick={() => copyTable(stock)}
                        />
                    </Grid>
                    <Table size="small" color="primary">
                        <TableHead>
                            <TableRow>
                                <TableCell>Código</TableCell>
                                <TableCell>Nome</TableCell>
                                <TableCell>Preço</TableCell>
                                <TableCell>Código fornecedor</TableCell>
                                <TableCell align="right">
                                    Estoque minimo
                                </TableCell>
                                <TableCell align="right">
                                    Estoque atual
                                </TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {stock.map((produto) => (
                                <TableRow key={produto.Id}>
                                    <TableCell>{produto.codigo}</TableCell>
                                    <TableCell>{produto.nome}</TableCell>
                                    <TableCell>{produto.preco}</TableCell>
                                    <TableCell>
                                        {produto.codigo_fornecedor}
                                    </TableCell>
                                    <TableCell align="right">
                                        {`${produto.estoque_minimo} unidades`}
                                    </TableCell>
                                    <TableCell align="right">
                                        {`${produto.estoque_atual} unidades`}
                                    </TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </Paper>
            </ThemeProvider>
        </>
    );
};

const mapStateToProps = (state) => ({ ...state });
const mapDispatchToProps = (dispatch) => {
    return bindActionCreators(ProdutoActions, dispatch);
};
export default connect(mapStateToProps, mapDispatchToProps)(Stock);
